module.exports = __webpack_public_path__ + "img/bg-shape-1.58cdf6db.png";